import React from "react";
import { Avatar } from "react-toolbox/lib/avatar";
import { Checkbox } from "react-toolbox/lib/checkbox";
import IndeterminateCheckboxButton from "components/IndeterminateCheckboxButton";
import MediaLink from "application/components/MediaLink";
import { getTitle, getSubtitle, getThumbnailUrl } from "util/mediaUtil";
import styles from "components/MediaListItem.css";

const getListClassName = (selected, disabled) => {
  if (selected && disabled) {
    return styles.listItemSelectedDisabled;
  } else if (selected) {
    return styles.listItemSelected;
  } else if (disabled) {
    return styles.listItemDisabled;
  } else {
    return styles.listItem;
  }
};

const MediaListItem = ({
  indeterminate,
  media,
  mediaLink,
  onSelected,
  selected,
  singleSelect,
  disabled,
  ...props
}) => (
  <li
    className={getListClassName(selected, disabled)}
    {...props}
    onClick={e => {
      e.stopPropagation();
      if (!disabled) {
        onSelected(!selected, media.id);
      }
    }}
  >
    {!singleSelect &&
      (!selected && indeterminate ? (
        <IndeterminateCheckboxButton
          onClick={(value, e) => e.stopPropagation()}
          className={styles.indeterminateCheckbox}
        />
      ) : (
        <Checkbox
          disabled={disabled}
          theme={styles}
          checked={selected}
          onChange={(value, e) => e.stopPropagation()}
        />
      ))}
    <div className={styles.titleColumn}>
      <div className={styles.avatarContainer}>
        <Avatar image={getThumbnailUrl(media)} />
      </div>
      <div className={styles.textContainer}>
        <span className={styles.itemTitle}>{getTitle(media)}</span>
        <span className={styles.itemSubTitle}>{getSubtitle(media)}</span>
      </div>
    </div>
    {mediaLink && (
      <div className={styles.actionColumn}>
        <MediaLink media={media} label="Explore" />
      </div>
    )}
  </li>
);

export default MediaListItem;
